// extracted by mini-css-extract-plugin
export default {"customPronouns":"KR_KWsFKHoz_h1bDK1yM"};